import React from 'react'
import { useTranslation } from 'react-i18next'
import { ErrorBoundary, FallbackProps } from 'react-error-boundary'

import { ResidentAppError } from '../../../../common/error'
import { ResidentAppErrorCode } from '../../../../common/types'

import { AccessDenied } from 'components/AccessDenied/AccessDenied'
import { Error } from 'components/Error'

interface ErrorHandlerProps {
  children: React.ReactNode
}

export const ErrorHandler: React.FC<ErrorHandlerProps> = ({ children }) => {
  const [t] = useTranslation(['payments'])

  const fallbackRender = ({ error, resetErrorBoundary }: FallbackProps) => {
    if (error instanceof ResidentAppError) {
      switch (error.errorCode) {
        case ResidentAppErrorCode.FEATURE_ACCESS_DENIED:
          return (
            <AccessDenied
              message={t('payments:errors.paymentsAccessDenied')}
              resetErrorBoundary={resetErrorBoundary}
            />
          )
        default:
      }
    }

    return <Error message={t('payments:errors.failedToLoadPaymentHistory')} />
  }

  return (
    <ErrorBoundary fallbackRender={fallbackRender}>{children}</ErrorBoundary>
  )
}
